<template>
  <v-layout>
    <v-flex lg6 offset-lg3>
      <jti-expansion-panel panelName="Master Card Contact Number Details">
        <v-container class="pa-2">
          <v-layout row wrap>
            <v-flex lg12>
              <v-form ref="formMasterCard">
                <v-text-field
                  v-model="data.first_name"
                  label="First Name"
                  :readonly="readonly"
                ></v-text-field>
                <v-text-field
                  v-model="data.last_name"
                  label="Last Name"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  :items="companies"
                  v-model="assignCompany"
                  label="Company"
                  :readonly="readonly"
                ></v-select>
                <v-select
                  :items="subcompanies"
                  v-model="assignSubCompany"
                  label="Subcompany"
                  :readonly="readonly"
                ></v-select>
                <!-- <v-select
                  v-if="(dialogType != 'add')"
                  v-model="data.contact_name"
                  :items="contacts"
                  label="Contact Name"
                  required
                  :rules="[rules.required]"
                  :readonly="readonly"
                ></v-select> -->
                <v-text-field
                  v-model="data.contact_no"
                  oninput="javascript: 
                    if (this.value.length > this.maxLength)
                     this.value = this.value.slice(0, this.maxLength);"
                  maxlength="10"
                  type="number"
                  label="Contact Number"
                  :counter="counter"
                  prefix="+63"
                  :readonly="readonly"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </jti-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import Services from "@/services/Services";

export default {
  props: {
    data: Object,
    readonly: Boolean,
    counter: Boolean,
    contacts: {
      type: Array,
      default: [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    dialogType: "",
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      assignContact: "",
      assignCompany: this.data.assignCompany,
      assignSubCompany: this.data.assignSubCompany,
      subcompanies: [],
    };
  },
  created: async function() {
    this.subcompanies = await this.getSubCompanies();
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        mastercard_contact_id: this.assignContact,
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        assignCompany: this.assignCompany,
        assignSubCompany: this.assignSubCompany,
        contact_no: this.data.contact_no,
      };
    },
  },
  watch: {
    assignContact: async function() {
      if (this.assignContact) {
        await this.setContactPreview();
      }
    },
    assignCompany: async function() {
      this.subcompanies = await this.getSubCompanies();
    },
  },
  methods: {
    validateForm() {
      return this.$refs.formMasterCard.validate();
    },
    async setContactPreview() {
      const items = (await Services.getMasterCardContact(this.assignContact))
        .data;

      this.data.contact_no = items.data.contact_no;
    },
    async getSubCompanies() {
      let finalData = [];

      const items = (
        await Services.getSubCompanies({
          project_id: this.$store.state.employee.project_id,
          company_id: this.assignCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };

        finalData.push(data);
      }

      return finalData;
    },
  },
};
</script>

<style scoped></style>
